<template>
  <v-radio-group v-model="impactType">
    <v-sheet
      outlined
      v-for="(item, i) in items"
      :key="i"
      rounded
      :color="activeCardStyle(item.impactType)"
      class="mb-2 py-n6"
    >
      <v-card flat @click="impactType = item.impactType">
        <v-list three-line>
          <v-list-item>
            <v-list-item-avatar tile size="60">
              <v-img v-if="item.src" :src="item.src" style="border-radius: 4px" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title
                >{{ $t(item.titleAlt) }}
                <v-chip v-if="item.showImpactFactorSlider" color="success" small>{{
                  $t("report.thgImpactTypeItems.sustainable.label")
                }}</v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                ><v-icon small>mdi-check</v-icon
                >{{ $t("report.thgImpactTypeItems.sustainable.first") }}</v-list-item-subtitle
              ><v-list-item-subtitle
                ><v-icon small>mdi-check</v-icon
                >{{ $t("report.thgImpactTypeItems.sustainable.second") }}</v-list-item-subtitle
              >
              <v-list-item-subtitle
                ><v-icon small>mdi-check</v-icon
                >{{ $t("report.thgImpactTypeItems.sustainable.third") }}</v-list-item-subtitle
              >
              <v-list-item-subtitle v-if="item.showImpactFactorSlider"
                ><v-icon small>mdi-check</v-icon>{{ $t(item.subtitleAlt) }}</v-list-item-subtitle
              >
              <div v-if="item.impactType === impactType && item.showImpactFactorSlider">
                <span class="font-weight-black text-h5" :style="`color:${color}`">{{ impactFactor + " %" }}</span>

                <thg-checkout-sustainable-factor-dialog @update="updateImpactFactor" :item="item" />
              </div>
            </v-list-item-content>
            <v-list-item-action>
              <v-radio :value="item.impactType"></v-radio>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </v-sheet>
  </v-radio-group>
</template>

<script lang="ts">
import { PartnerColor } from "@/lib/partnerColor";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";
import { Component, Prop, Vue } from "vue-property-decorator";
import ThgCheckoutSustainableFactorDialog from "./ThgCheckoutSustainableFactorDialog.vue";

@Component({
  components: {
    ThgCheckoutSustainableFactorDialog
  }
})
export default class ThgCheckoutSustainableCard extends Vue {
  @Prop({ default: false })
  hideEdit?: boolean;

  get color() {
    return this.$vuetify.theme.dark ? "white" : this.$vuetify.theme.themes.light.primary;
  }

  get impactFactor() {
    return ThgCreateModule.impactFactor;
  }

  set impactFactor(impactFactor: number) {
    ThgCreateModule.setImpactFactor(impactFactor);
  }

  updateImpactFactor(impactFactor: number) {
    this.impactFactor = impactFactor;
  }

  get icon(): string {
    return ThgCreateModule.impactTypeItem.icon;
  }

  get impactType() {
    return ThgCreateModule.impactType;
  }

  set impactType(type: ImpactTypeEnum) {
    let setImpactFactor = false;
    if (type !== this.impactType) {
      setImpactFactor = true;
    }
    ThgCreateModule.setImpactType(type);

    /**
     * Only set impacfactor to base factor if impact item changes
     */
    if (setImpactFactor) {
      ThgCreateModule.setImpactFactor(ThgCreateModule.impactTypeItem.baseImpactFactor);
    }
  }

  activeCardStyle(type: ImpactTypeEnum) {
    if (this.impactType === type) {
      return "primary";
    }
    return "";
  }

  get items() {
    return ThgCreateModule.activeImpactTypeItemsOrdered;
  }

  partnerColor = new PartnerColor();
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
